import React from 'react';

/**
 * HOC that wraps TopBarEnvironmentIndicator to inject backendSpecs actions and selectors
 */
const TopBarEnvironmentIndicatorWrapper = (Original, system) => {
  const Wrapper = (props) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;

    return (
      <Original
        {...props}
        backendSpecsActions={backendSpecsActions}
        backendSpecsSelectors={backendSpecsSelectors}
      />
    );
  };

  return Wrapper;
};

export default TopBarEnvironmentIndicatorWrapper;
